<template>
  <div class="columns is-mobile">
    <div class="column is-12 pl-6">
      <div
        v-for="(item, index) in activeJobs"
        :key="`${item.username}-${index}`"
      >
        <div class="columns card is-multiline is-half-mobile mb-6">
          <div class="column is-2 has-text-centered has-margin-auto is-size-1">
            <figure>
              <img :src="`${item.profile_picture}`" alt="user-profile" />
            </figure>
          </div>
          <div class="column is-4-desktop">
            <div>
              <span class="has-text-grey is-size-7"
                >{{ $t('Work Experience') }}:</span
              >
              <span class="has-text-weight-bold is-size-7">{{
                getExperience(item.experience_months)
              }}</span>
            </div>
            <div>
              <span class="has-text-grey is-size-7"
                >{{ $t('Expected Salary') }}:</span
              >
              <span class="has-text-weight-bold is-size-7">
                {{ item.expected_salary || 'N/A' }}
              </span>
            </div>
            <div>
              <span class="has-text-grey is-size-7"
                >{{ $t('Preferred Job Location') }}:</span
              >
              <span class="has-text-weight-bold is-size-7"
                >{{ item.preferred_locations.map(obj => ' ' + obj).toString() }}
              </span>
            </div>
            <div>
              <span class="has-text-grey is-size-7">{{ $t('skills') }}:</span>
              <span class="has-text-weight-bold is-size-7"
                >{{ item.skills.map(obj => ' ' + obj).toString() }}
              </span>
              <b
                v-if="!item.skills.length"
                class="is-size-7"
                v-text="$t('N/A')"
              ></b>
            </div>
            <div>
              <span class="has-text-grey is-size-7"
                >{{ $t('Working Status') }}:</span
              >
              <span class="has-text-weight-bold is-size-7">{{
                $t(item.working_status) || 'N/A'
              }}</span>
            </div>
          </div>
          <div class="column is-4 is-right-paddingless">
            <div>
              <span class="has-text-grey is-size-7"
                >{{ $t('Education') }}:</span
              >
              <span class="has-text-weight-bold is-size-7">
                {{ item.education || $t('N/A') }}</span
              >
            </div>
            <div>
              <span class="has-text-grey is-size-7">{{ $t('Age') }}:</span>
              <span class="has-text-weight-bold is-size-7">{{ item.age }}</span>
            </div>
            <div>
              <span class="has-text-grey is-size-7">{{ $t('Gender') }}:</span>
              <span class="has-text-weight-bold is-size-7">
                {{ $t(item.gender) || $t('N/A') }}
              </span>
            </div>
            <div>
              <span class="has-text-grey is-size-7"
                >{{ $t('Preferred Job') }}:</span
              >
              <span class="has-text-weight-bold is-size-7"
                >{{
                  item.job_categories.length
                    ? item.job_categories.map(obj => ' ' + obj).toString()
                    : $t('N/A')
                }}
              </span>
            </div>
          </div>
          <div class="column is-half-mobile is-2 is-left-paddingless">
            <div class="has-margin-bottom-5">
              <client-only>
                <button
                  v-if="
                    !$store.getters[
                      'shoppingCart/isShortlistedEmployerJobseeker'
                    ](item.username)
                  "
                  class="button is-small has-text-white has-background-danger"
                  @click="shortlistJobSeeker(item)"
                >
                  {{ $t('Shortlist') }}
                </button>
                <button
                  v-else
                  class="button is-small has-text-white has-background-success"
                  @click="removeShortlistedJobseeker(item)"
                >
                  {{ $t('Shortlisted') }}
                </button>
              </client-only>
            </div>
            <button
              v-if="
                showLikeButton &&
                $store.state.auth.loggedIn &&
                $store.state.auth.user.employer_profile
              "
              class="button is-small"
              @click="likeJobseeker(item, index)"
            >
              <div class="columns is-mobile">
                <div class="icon column is-narrow has-margin-right-10">
                  <vue-icon-base
                    height="14"
                    width="14"
                    :path="$options.icons[$kc('uni-thumbs-up')]"
                    :icon-color="item.liked ? '#3298dc' : ''"
                  >
                  </vue-icon-base>
                </div>
                <div
                  class="column is-left-paddingless"
                  :class="item.liked ? 'has-text-info' : ''"
                >
                  {{ item.liked ? $t('Liked') : $t('Like') }}
                </div>
              </div>
            </button>
          </div>
        </div>
        <div v-if="googleAd[index]" class="mb-9 has-text-centered pr-5">
          <dfp-slot
            :id="`div-gpt-ad-${googleAd[index].id}-0`"
            mapping-job-search
            :path="`/35754210/${googleAd[index].code}`"
            :size="[
              [728, 90],
              [320, 100]
            ]"
          />
        </div>
      </div>
      <hr class="is-marginless" />
    </div>
  </div>
</template>
<script>
import VueIconBase from '@/components/Commons/VueIconBase'
import { uniUser, uniThumbsUp } from '@/helpers/icons'
import DfpSlot from '@/components/DfpSlot'

export default {
  icons: {
    uniUser,
    uniThumbsUp
  },
  components: {
    VueIconBase,
    DfpSlot
  },
  props: {
    activeJobs: {
      type: Array,
      required: true
    },
    showLikeButton: {
      type: Boolean,
      default: true
    },
    collectionName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      shortlistedItems: [],
      googleAd: {
        2: {
          id: 1580380019439,
          code: 'RJ_JS_L4'
        },
        5: {
          id: 1580380062513,
          code: 'RJ_JS_L5'
        },
        6: {
          id: 1580380105108,
          code: 'RJ_JS_L6'
        }
      }
    }
  },
  methods: {
    shortlistJobSeeker(item) {
      if (this.$auth.user && this.$auth.user.employer_profile) {
        this.$axios
          .$post('api/v1/payment/hiring-package/check-redundant-js/', {
            jobseeker: item.username
          })
          .then(response => {
            if (response.status === 200) {
              this.$axios
                .$post(`/api/v1/payment/hiring-package/`, {
                  jobseekers: [item.username]
                })
                .then(() => {
                  this.$emit('refresh')
                  this.$store.dispatch(
                    'shoppingCart/addToEmployerJobseekerShortlist',
                    item
                  )
                })
                .catch(error => {
                  this.notifyError(
                    error.response.data.error || error.response.data.detail
                  )
                })
            } else {
              this.notifyError(
                'The data of the Job Seeker you are trying to shortlist is already purchased.'
              )
            }
          })
          .catch(() => {
            this.notifyError(
              'The data of the Job Seeker you are trying to shortlist is already purchased.'
            )
          })
      } else {
        this.$store.dispatch(
          'shoppingCart/addToEmployerJobseekerShortlist',
          item
        )
      }
    },
    removeShortlistedJobseeker(item) {
      if (this.$auth.user && this.$auth.user.employer_profile) {
        this.$axios
          .$post(`/api/v1/payment/hiring-package/delete/`, {
            jobseeker: item.username
          })
          .then(() => {
            this.$emit('refresh')
            this.$store.dispatch(
              'shoppingCart/removeFromEmployerJobseekerShortlist',
              item
            )
          })
          .catch(error => {
            this.notifyError(error.response.data.error)
          })
      } else {
        this.$store.dispatch(
          'shoppingCart/removeFromEmployerJobseekerShortlist',
          item
        )
      }
    },
    likeJobseeker(item, index) {
      const urlSuffix = item.liked ? 'unlike' : 'like'
      this.$axios
        .$post(`/api/v1/jobseekers/search/${item.username}/${urlSuffix}/`, {
          user__name: item.username
        })
        .then(response => {
          this.$store.commit('collection/modifyLeaf', {
            path: [this.collectionName, 'results', index, 'liked'],
            data: response.liked
          })
          this.$emit('refresh')
        })
    },
    getExperience(value) {
      if (value >= 12) {
        const yearValue = Math.floor(value / 12)
        const monthValue = value % 12
        return (
          (yearValue ? `${yearValue} ${this.$t('Year')} ` : '') +
          (monthValue ? `${monthValue} ${this.$t('Months')}` : '')
        )
      } else {
        return value ? `${value} ${this.$t('Months')}` : 'N/A'
      }
    }
  }
}
</script>
